/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { DateTime } from '@easepick/bundle';
import { SdsDivProps } from '../Component.props';
import { PICKER_DATE_FORMAT, PICKER_TIME_FORMAT } from './DatetimePicker.constants';
import { DatetimePickerResult, DatetimePickerTypes, SingleDatetimePickerResult } from './DatetimePicker.defs';

/**
 * The props for `<DatetimePicker />`.
 */
export interface DatetimePickerProps extends SdsDivProps {
  /**
   * The function to return the chosen value.
   */
  callback(result: DatetimePickerResult | SingleDatetimePickerResult | string): void;

  /**
   * The function to execute along when clearing date with native controls.
   */

  clearCallback?: () => void;

  /**
   * The classes to add to the component.
   */
  classes?: string;
  /**
   * The datetime format for the selected date(s).
   */
  format?: string;

  /**
   * The maximum selectable date.
   */
  dateMaximum?: DateTime;

  /**
   * The minimum selectable date.
   */
  dateMinimum?: DateTime;

  /**
   * The placeholder text for the input field.
   */
  placeholder?: string;

  /**
   * The preset selected end datetime in milliseconds.
   */
  presetEndDatetime?: number;

  /**
   * The date that should be selected/preselected.
   * Prop selectedDate must be in format of STRING TIMESTAMP i.e. 1792030402, otherwise it might cause errors - use new Date($your_date).getTime().toString() to make it work correctly when passing in non-timestamp data.
   */
  selectedDate?: string;
  /**
   * The types of DatetimePicker.
   */
  type?: DatetimePickerTypes;
  /**
   * The preset selected start datetime in milliseconds.
   */
  presetStartDatetime?: number;
}

/**
 * The default prop values for `<DatetimePicker />`.
 */
export const datetimePickerDefaults = {
  format: `${PICKER_DATE_FORMAT} ${PICKER_TIME_FORMAT}`,
  placeholder: `Select time and date range`,
};
